import { gql } from "@apollo/client";
import { client } from "..";

const insertApiUser = gql`
mutation Insert_User($phone_number: String = "", $name: String = "") {
  insert_apiuser(objects: {phone_number: $phone_number, name: $name}, on_conflict: {constraint: user_phone_number_key, update_columns: [updated_at,name]}) {
    affected_rows
    returning {
      id
      name
      phone_number
    }
    }
}
`

export const CreateApiUser = async (
    name,mobile
) => {
    let resp;
    const value = {
        "name": name,
        "phone_number": mobile,        
    }
    try {
        resp = await client.mutate({
            mutation: insertApiUser,
            refetchQueries: [],
            variables: value,
            context: {
                headers: {
                    "Content-Type": "application/json",
                    authorization:
                        `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`,
                },
            },
        });
        if (resp.errors) {
            console.log(resp.errors)
            // message.error(resp.errors);
            return resp.errors
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
    }
    // message.success(`Product ${data?.name} Created Successfully!'`, 5);
    return resp;
};